import React, { useEffect, useState, useRef } from 'react'

import { useInView } from 'react-cool-inview'

import { string } from 'prop-types'

import useApiGet from 'Pods/Shared/Hooks/useApiGet'
import i18nHome from 'Pods/Shared/I18nHome'

function PrintModelsFeaturedDesigners({ locale = 'en' }) {
  const [loadedComponent, setLoadedComponent] = useState(false)
  const [designersInfo, setDesignersInfo] = useState(null)
  const [FeaturedDesignerComponent, setFeaturedDesignerComponent] = useState(null)

  const componentLoadedRef = useRef(false)
  const dataFetchedRef = useRef(false)

  const { getData } = useApiGet()

  const { observe, inView } = useInView({
    rootMargin: '-100px 0px',
    threshold: 0,
    onEnter: ({ unobserve }) => {
      unobserve()
    },
  })

  useEffect(() => {
    if (!inView) return

    if (!componentLoadedRef.current && !loadedComponent) {
      componentLoadedRef.current = true

      import('Pods/LazyLoaded/NewDesignerSection/NewDesignerSection')
        .then((module) => {
          setFeaturedDesignerComponent(() => module.default)
          setLoadedComponent(true)
        })
        .catch((err) => {
          componentLoadedRef.current = false
          if (window.Sentry) {
            window.Sentry.captureException(err)
          }
        })
    }

    if (!dataFetchedRef.current && !designersInfo) {
      dataFetchedRef.current = true

      getData({
        path: '/api/internal/featured_designers',
        params: { print_model: true, sample_size: 3, locale },
        onSuccess: (response) => {
          setDesignersInfo(response.data)
        },
        onError: () => {
          dataFetchedRef.current = false
        },
      })
    }
  }, [inView, loadedComponent, designersInfo, getData, locale])

  const featuredDesignerTitle = i18nHome.t('featuredDesigner.title', { ns: 'new-home', lng: locale })

  return (
    <div ref={observe}>
      {FeaturedDesignerComponent && designersInfo && Array.isArray(designersInfo) && designersInfo.length > 0 && (
        <div className="featured-designers-container">
          <h2 className="featured-designers-container__title">{featuredDesignerTitle}</h2>
          <div className="featured-designers-container__list">
            {designersInfo.map((designer) => (
              <FeaturedDesignerComponent
                key={designer.id}
                userInfo={designer}
                locale={locale}
                showTitle={false}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

PrintModelsFeaturedDesigners.propTypes = {
  locale: string,
}

export default PrintModelsFeaturedDesigners
